import * as React from 'react'
import { JobNumberShape } from '../../api/api_data_types'

type JobNumberDetailsProps = {
  jobnumber: JobNumberShape
}
export default function JobNumberDetails({ jobnumber }: JobNumberDetailsProps) {
  if (!jobnumber) {
    return null
  }

  return (
    <>
      {jobnumber.global_dimension_1_code && (
        <div className="mr-3">
          <span className="mr-1">Produceres i:</span>
          {jobnumber.global_dimension_1_code}
        </div>
      )}
      {jobnumber.salesperson && (
        <div className="mr-3">
          <span className="mr-1">Sælger:</span>
          {jobnumber.salesperson}
        </div>
      )}
      {jobnumber.project_manager && (
        <div className="mr-3">
          <span className="mr-1">Projektansvarlig:</span>
          {jobnumber.project_manager}
        </div>
      )}
      {jobnumber.coordinator && (
        <div className="mr-3">
          <span className="mr-1">Orderstyrer:</span>
          {jobnumber.coordinator}
        </div>
      )}
    </>
  )
}
